import { Briefcase } from "lucide-react";

const EmptyJobState = () => {
  return (
    <div className="bg-white text-center py-16 rounded-2xl shadow-lg border border-gray-100">
      <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <Briefcase className="w-10 h-10 text-gray-400" />
      </div>
      <h3 className="text-2xl font-semibold text-gray-900 mb-2">
        No jobs found
      </h3>
      <p className="text-gray-600">
        Create your first job posting to get started with recruitment.
      </p>
    </div>
  );
};

export default EmptyJobState;
